// Scroll behavior: add/remove "scrolled" class on navbar
function initScrollBehavior() {
  const navbar = document.getElementById("main-navbar");
  if (!navbar) return;

  let ticking = false;

  function updateNavbar() {
    if (window.scrollY > 20) {
      navbar!.classList.add("scrolled");
    } else {
      navbar!.classList.remove("scrolled");
    }
    ticking = false;
  }

  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(updateNavbar);
      ticking = true;
    }
  }, { passive: true });

  updateNavbar();
}

// Mobile menu toggle
function initMobileMenu() {
  const toggleBtn = document.getElementById("mobile-menu-toggle");
  const menu = document.getElementById("mobile-menu");
  if (!toggleBtn || !menu) return;

  function openMenu() {
    menu!.classList.add("open");
    toggleBtn!.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  }

  function closeMenu() {
    menu!.classList.remove("open");
    toggleBtn!.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
  }

  toggleBtn.addEventListener("click", () => {
    if (menu.classList.contains("open")) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // Close buttons (backdrop + X button)
  menu.querySelectorAll("[data-mobile-menu-close]").forEach((el) => {
    el.addEventListener("click", closeMenu);
  });

  // Close on link click
  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeMenu);
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initScrollBehavior();
    initMobileMenu();
  });
} else {
  initScrollBehavior();
  initMobileMenu();
}

export {};
